import { render, staticRenderFns } from "./setAboutUs.vue?vue&type=template&id=7b61bbb2&"
import script from "./setAboutUs.vue?vue&type=script&lang=js&"
export * from "./setAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./setAboutUs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports